<div class="{{isLoading}}"></div>
<div class="snackbar {{show}}">{{message}}</div>
<section class="dress">
    <div class="main">
        <div class="gallery" *ngIf="isLoading!='loading'">
            <div class="big-picture"><img src="{{displayPic}}"></div>
            <div class="small-pictures">
                <img src="{{dress.pic_urls[0]}}" (click)="changeDisplayPic(dress.pic_urls[0])">
                <img src="{{dress.pic_urls[1]}}" (click)="changeDisplayPic(dress.pic_urls[1])">
                <img src="{{dress.pic_urls[2]}}" (click)="changeDisplayPic(dress.pic_urls[2])">
            </div>
        </div>
        <div class="details">
            <h1>{{dress.dress_name}}</h1>
            <h2>Size: {{dress.size}} 
                <span *ngIf="reviewAverage==0">
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                </span>

                <span *ngIf="reviewAverage==1">
                    <i class="fas fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                </span>

                <span *ngIf="reviewAverage==2">
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                </span>

                <span *ngIf="reviewAverage==3">
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="far fa-heart"></i>
                    <i class="far fa-heart"></i>
                </span>

                <span *ngIf="reviewAverage==4">
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="far fa-heart"></i>
                </span>

                <span *ngIf="reviewAverage==5">
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                    <i class="fas fa-heart"></i>
                </span>
            </h2>
            <div class="dress-details">
                <p>Shoulders: {{dress.shoulder}}</p>
                <p>Neck: {{dress.neck}}</p>
                <p>Waist: {{dress.waist}}</p>
                <p>Sleeves: {{dress.sleeves}}</p>
            </div>
            <p>
                Status:
                <span *ngIf="dress.status=='1'">Dress is available to rent</span>
                <span *ngIf="dress.status=='2'">Dress is not currently available to rent</span>
            </p>
            <span class="days"><input min="1" type="number" style="width:3em; height:2em" name='days' [(ngModel)]='days'> No. of Days</span>
            <h3 class="rent">Rent: {{dress.basic_rent}}</h3>
            <button *ngIf="dress.status=='1'" class="add" (click)='addToCart(dress)'>Add to Cart</button>
            <button *ngIf="dress.status=='2'" class="add disabled" disabled>Add to Cart</button>
        </div>
    </div>
    <div class="description">
        <div class="full-details">
            <h2>Description</h2>
            <p>
                {{dress.description}}
            </p>
            <div class="dress-details">
                <p>Shoulders: {{dress.shoulder}}</p>
                <p>Neck: {{dress.neck}}</p>
                <p>Waist: {{dress.waist}}</p>
                <p>Sleeves: {{dress.sleeves}}</p>
            </div>
            <h2>Return Policy</h2>
            <p>
                {{dress.return_policy}}
            </p>
        </div>
    </div>
    <div class="reviews">
        <h2>Reviews</h2>
        <div class="review" *ngIf="empty=='empty'">
            <div class="comment">No Reviews found for this dress</div>
        </div>
        <div *ngIf="empty==''">
            <div class="review" *ngFor="let review of reviews; index as i">
                <div class="name">
                    <h4>{{review.customer_id.first_name}} {{review.customer_id.last_name}}</h4>
                </div>
                <div class="comment">{{review.remarks}}</div>
                <div class="rating">
                    <span *ngIf="review.rating==0">
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                    </span>

                    <span *ngIf="review.rating==1">
                        <i class="fas fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                    </span>

                    <span *ngIf="review.rating==2">
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                    </span>

                    <span *ngIf="review.rating==3">
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="far fa-heart"></i>
                        <i class="far fa-heart"></i>
                    </span>

                    <span *ngIf="review.rating==4">
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="far fa-heart"></i>
                    </span>

                    <span *ngIf="review.rating==5">
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                        <i class="fas fa-heart"></i>
                    </span>
                </div>
            </div>
        </div>

    </div>
</section>